import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import { Bar } from 'react-chartjs-2';
import Typography from '@material-ui/core/Typography';
import { styles } from '../CSS/Styles';


class ManagementChart extends Component {

    render() {
        const { classes } = this.props
        let data = this.props.data
        let option = {
            plugins: {
                datalabels: {
                    display: ((context)=>{
                        return context.dataset.data[context.dataIndex] !== 0
                    }),
                    color: 'white',
                    anchor: 'end',
                    align: 'start'
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    gridLines: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        beginAtZero: true,
                        display: false
                    }
                }],
                xAxes: [{
                    barPercentage: 0.65,
                    gridLines: {
                        display: false,
                        drawBorder: true
                    },
                    ticks: {
                        fontSize: 10
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'Amount'
                    }
                }]
            },
            title: {
                display: false
            },
            legend: {
                position:'bottom',
                display: false
            }
        }

        return (
            <div className={classes.details}>
                {this.props.title === null ? null :
                    this.props.title.map((title, index) => {
                        if (index === 0) {
                            return (
                                <Typography className={classes.title}>
                                    {title}
                                </Typography>
                            )
                        }
                        if (title === '') {
                            return (
                                <Typography className={classes.subtitle}/>
                            )
                        }
                        return (
                            <div>
                                {title.split(' ').map((title)=>{
                                    return (
                                        <Typography variant='subtitle' style={{ color:(isNaN(title) ? 'black' : 'blue'), display:'inline', minHeight: '18px'}}>
                                            {title + ' '}
                                        </Typography>
                                    )
                                })}
                            </div>
                        )
                    })
                }
                <br/>
                <Bar data={data} height={100} options={option} onElementsClick={(element)=>{
                    console.log(element)
                    if (element[0] != null && this.props.eEvent != null) {
                        console.log(element[0])
                        this.props.eEvent(element[0]._model.label)
                    }
                }}/>
            </div>
        )
    }
}
export default withStyles(styles)(ManagementChart);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/chart.js